// Firebase Analytics 工具函數
import { logEvent, setUserProperties, setUserId } from 'firebase/analytics';
import { analytics } from '../firebase';

// 檢查Analytics是否可用
const isAnalyticsAvailable = () => {
  return analytics !== null && typeof window !== 'undefined';
};

// 追蹤自定義事件
export const logFirebaseEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (isAnalyticsAvailable()) {
    logEvent(analytics!, eventName, parameters);
  }
};

// 追蹤AI聊天事件
export const logAIChatEvent = (action: string, parameters?: Record<string, any>) => {
  logFirebaseEvent('ai_chat_interaction', {
    action,
    timestamp: new Date().toISOString(),
    ...parameters,
  });
};

// 追蹤政策相關事件
export const logPolicyEvent = (action: string, parameters?: Record<string, any>) => {
  logFirebaseEvent('policy_interaction', {
    action,
    timestamp: new Date().toISOString(),
    ...parameters,
  });
};

// 追蹤用戶旅程
export const logUserJourney = (step: string, parameters?: Record<string, any>) => {
  logFirebaseEvent('user_journey', {
    step,
    timestamp: new Date().toISOString(),
    ...parameters,
  });
};

// 追蹤轉換事件
export const logConversion = (conversionType: string, value?: number, parameters?: Record<string, any>) => {
  logFirebaseEvent('conversion', {
    conversion_type: conversionType,
    value: value || 0,
    timestamp: new Date().toISOString(),
    ...parameters,
  });
};

// 追蹤頁面瀏覽
export const logPageView = (pageName: string, parameters?: Record<string, any>) => {
  logFirebaseEvent('page_view', {
    page_name: pageName,
    timestamp: new Date().toISOString(),
    ...parameters,
  });
};

// 追蹤錯誤
export const logError = (errorType: string, errorMessage: string, parameters?: Record<string, any>) => {
  logFirebaseEvent('error_occurred', {
    error_type: errorType,
    error_message: errorMessage,
    timestamp: new Date().toISOString(),
    ...parameters,
  });
};

// 設置用戶屬性
export const setUserProperty = (propertyName: string, value: string | number | boolean) => {
  if (isAnalyticsAvailable()) {
    setUserProperties(analytics!, {
      [propertyName]: value,
    });
  }
};

// 設置用戶ID
export const setFirebaseUserId = (userId: string) => {
  if (isAnalyticsAvailable()) {
    setUserId(analytics!, userId);
  }
};

// 追蹤應用啟動
export const logAppStart = () => {
  logFirebaseEvent('app_start', {
    timestamp: new Date().toISOString(),
    user_agent: navigator.userAgent,
    screen_resolution: `${window.screen.width}x${window.screen.height}`,
    viewport_size: `${window.innerWidth}x${window.innerHeight}`,
  });
};

// 追蹤功能使用
export const logFeatureUsage = (featureName: string, parameters?: Record<string, any>) => {
  logFirebaseEvent('feature_usage', {
    feature_name: featureName,
    timestamp: new Date().toISOString(),
    ...parameters,
  });
};

// 追蹤性能指標
export const logPerformance = (metricName: string, value: number, unit?: string) => {
  logFirebaseEvent('performance_metric', {
    metric_name: metricName,
    metric_value: value,
    metric_unit: unit || 'ms',
    timestamp: new Date().toISOString(),
  });
};
